import PropTypes from 'prop-types';
import cn from 'classnames';

import DesktopTabButtons from './DesktopTabButtons.jsx';
import MobileTabButtons from './MobileTabButtons.jsx';

export default function LdsTabs({
  id,
  className = '',
  activeTab,
  ariaLabel,
  tabAlign = 'align-left',
  tabStyle = 'card',
  onChange,
  tabLabels = [],
  children,
  ...rest
}) {
  const handleTabClick = (e, tabId) => {
    onChange(tabId);
    e.target.focus();
  };

  return (
    <div
      className={cn(
        'lds-tab-group',
        {
          'lds-card': tabStyle === 'card',
          'full-width': tabStyle !== 'card',
        },
        className
      )}
      id={id}
      aria-label={ariaLabel}
      {...rest}
    >
      <div
        className={cn(
          'lds-tab-header',
          {
            [tabAlign]: tabAlign,
          }
        )}
      >
        <DesktopTabButtons
          activeTab={activeTab}
          tabStyle={tabStyle}
          handleTabClick={handleTabClick}
          tabLabels={tabLabels}
        />
        <MobileTabButtons
          activeTab={activeTab}
          handleTabClick={handleTabClick}
          tabLabels={tabLabels}
          groupId={id}
        />
      </div>
      <div
        tabIndex={0}
        className={cn(
          'lds-tab-container',
          {
            'tab-padded': tabStyle === 'card',
            wrapper: tabStyle !== 'card',
          }
        )}
      >
        {children}
      </div>
    </div>
  );
}

LdsTabs.propTypes = {
  id: PropTypes.string.isRequired,
  activeTab: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func.isRequired,
  tabLabels: PropTypes.array.isRequired,
};
